import React, { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../../store";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../../../util/apiClient";
import CommonAlert from '../../Common/CommonAlert';
import MyDialogComponent from "../../Common/MyDialogComponent";
import EditForm from "../Module/EditForm";
import FormulaireGroupeFonctionnalite from "./FormulaireGroupeFonctionnalite";
import { addGroupeFonctionnalites, editGroupeFonctionnalite, setObjGroupeFonctionnalite, setOpenDialogGF, setValueEdit } from "./groupeFonctionnaliteSlice";








const AddGroupeFonctionnalite = () => {

    //redux
    const dispatch = useDispatch()
    const { objSousModule } = useSelector((state: IReduxState) => state.sousModule);
    // console.log("🚀 ~ file objSousModule", objSousModule)
    const { openDialogGF, valueEdit, objGroupeFonctionnalite } = useSelector((state: IReduxState) => state.groupeFonctionnalite);


    //hooks
    const [valueGF, setValueGF] = useState("");
    const [openAlert, setOpenAlert] = useState(false);


    const handleSave = async () => {
        try {
            const apiPayload = { idSousModule: objSousModule.idSousModule, libelleGroupeFonctionnalite: valueGF }
            console.log("🚀 ~ file: AddGroupeFonctionnalite.tsx ~ line 36 ~ handleSave ~ apiPayload", apiPayload)
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/creergroupefonctionnalite", apiPayload)
            if (res.status === 1) {
                const newGF = { ...res.data, id: res.data.idGroupeFonctionnalite, libelle: res.data.libelleGroupeFonctionnalite }
                dispatch(addGroupeFonctionnalites(newGF))
                dispatch(setOpenDialogGF(false))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddGroupeFonctionnalite.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    }


    const editItem = async () => {
        try {
            const apiPayload = {idSousModule:objSousModule.idSousModule, idGroupeFonctionnalite: objGroupeFonctionnalite.idGroupeFonctionnalite, libelleGroupeFonctionnalite: valueEdit }
            const res: any = await apiClient.post(ADMIN_SERVER_BASE_URL, "/tablesystem/modifiergroupefonctionnalite", apiPayload)
            if (res.status === 1) {
                const newGF = { ...res.data, id: res.data.idGroupeFonctionnalite, libelle: res.data.libelleGroupeFonctionnalite }
                dispatch(editGroupeFonctionnalite(newGF))
                dispatch(setOpenDialogGF(false))
            } else {
                console.log("status !==1")
            }

        } catch (error) {
            console.log("🚀 ~ file: AddModule.tsx ~ line 51 ~ handleSave ~ error", error)

        }
    };

    const handleOpen = () => {
        //verifier si un module a été selectionné avant d'ouvir le dialog d'enreegistrement du sous module
        if (Object.keys(objSousModule).length > 0) {
            dispatch(setOpenDialogGF(true));
            dispatch(setObjGroupeFonctionnalite({}));
            setValueGF("")
        } else {
            setOpenAlert(true)
        }
    };

    const handleClose = () => {
        dispatch(setOpenDialogGF(false));
    };

    const handleAlertClose = () => {
        setOpenAlert(false)
    }

    return (
        <div>
            <MyDialogComponent
                // dialogTitle={`${Object.keys(objGroupeFonctionnalite).length > 0 ? "Modifier" + " " + objGroupeFonctionnalite.libelleGroupeFonctionnalite : " Créer un Groupe fonctionnalite"}`}
               
                dialogTitle={`${
                    Object.keys(objGroupeFonctionnalite).length > 0
                      ? `Modifier ${objGroupeFonctionnalite.libelleGroupeFonctionnalite}`
                      : `Créer un Groupe fonctionnalite`
                  }`}
               
                dialogContent={
                    Object.keys(objGroupeFonctionnalite).length > 0
                        ? <EditForm setValueEdit={setValueEdit} valueEdit={valueEdit} />
                        : <FormulaireGroupeFonctionnalite
                            valueGF={valueGF}
                            setValueGF={setValueGF}
                        />}
                handleSave={
                    Object.keys(objGroupeFonctionnalite).length > 0
                        ? editItem
                        : handleSave
                }
                openDialog={openDialogGF}
                handleOpen={handleOpen}
                handleClose={handleClose}
            />
            <CommonAlert
                severity="warning"
                variant="filled"
                description="Veuillez selectionner un sous module."
                title="Alerte !"
                openAlert={openAlert}
                handleAlertClose={handleAlertClose}
            />
        </div>
    );
}

export default AddGroupeFonctionnalite;
